import { IconWrapper, SvgIcon } from '../Icon';
import toastMessage from '../../utils/toastMessage';
import { useAnalytics } from '../../utils/analytics/useAnalytics';
import { buttonClicked } from '../../utils/analytics/events/button/events';
import KubitTooltip from '../KubitTooltip';
import copyTextToClipboard from '../../utils/copyTextToClipboard';

interface IProps {
  text: string;
  trackContext: string;
  trackAction: string;
}
const ExplainWithAiCopyToClipboard = ({
  text,
  trackContext,
  trackAction,
}: IProps) => {
  const { track } = useAnalytics();
  const handleCopyToClipboard = async () => {
    await copyTextToClipboard(text);

    track(buttonClicked({ context: trackContext, action: trackAction }));
    toastMessage({
      message: `AI Response Text Copied!`,
      type: 'info',
    });
  };

  return (
    <KubitTooltip
      content={'Copy Response Text to Clipboard'}
      placement="top-start"
      noOpenDelay={true}
    >
      <IconWrapper size={24} onClick={handleCopyToClipboard}>
        <SvgIcon
          name={'clipboard-text'}
          width={24}
          height={24}
          customFill="currentColor"
        />
      </IconWrapper>
    </KubitTooltip>
  );
};

export default ExplainWithAiCopyToClipboard;
